import {
  SITE_NAME,
  OG_IMAGE_PATH,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_TYPE
} from './site'

export { SITE_NAME, OG_IMAGE_PATH, OG_IMAGE_WIDTH, OG_IMAGE_HEIGHT, OG_IMAGE_TYPE }

export const DEFAULT_PAGE_META = {
  title: `${SITE_NAME} - Home`,
  description:
    'Safe Haven Wellness Group offers healing through lived mental health experience (LMHE) — a safe, inclusive space where survival becomes wisdom.',
  ogImage: OG_IMAGE_PATH,
  ogImageWidth: OG_IMAGE_WIDTH,
  ogImageHeight: OG_IMAGE_HEIGHT,
  ogImageType: OG_IMAGE_TYPE,
  ogImageAlt: 'Safe Haven Wellness Group logo',
  ogType: 'website',
  twitterCard: 'summary_large_image',
  robots: 'index, follow',
  includeOrganizationJsonLd: true
}

export const JOIN_PAGE_META = {
  title: 'Join Our Community - Safe Haven Wellness Group',
  description:
    'Apply to join Safe Haven Wellness Group. Complete the intake membership application for our safe, peer-led community focused on healing through lived mental health experience (LMHE).',
  ogTitle: 'Join Safe Haven Wellness Group',
  ogDescription:
    'Start your intake membership application and join a compassionate community for healing, peer support, and lived mental health experience.',
  ogImage: OG_IMAGE_PATH,
  ogImageWidth: OG_IMAGE_WIDTH,
  ogImageHeight: OG_IMAGE_HEIGHT,
  ogImageType: OG_IMAGE_TYPE,
  ogImageAlt: 'Join Safe Haven Wellness Group community',
  ogType: 'website',
  twitterCard: 'summary_large_image',
  robots: 'index, follow',
  canonicalPath: '/join'
}
